import { render, staticRenderFns } from "./TableBlock.vue?vue&type=template&id=1384ecf0&scoped=true"
import script from "./TableBlock.vue?vue&type=script&lang=js"
export * from "./TableBlock.vue?vue&type=script&lang=js"
import style0 from "./TableBlock.vue?vue&type=style&index=0&id=1384ecf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1384ecf0",
  null
  
)

export default component.exports